import { Box, Grid, IconButton, Paper, Typography } from "@material-ui/core"
import React, { useEffect, useState } from "react"
import TableViewSwitch from "./TableViewSwitch"
import moment from "moment"
import { makeStyles, useTheme } from "@material-ui/core/styles"
import { useTranslation } from "react-i18next"
import { roles } from "../../data/roles"
import { useDispatch, useSelector } from "react-redux"
import UserReviewHeader from "./UserReviewHeader"
import UserReviewTabularView from "./UserReviewOverview/TabularView"
import TabularView from "./ReviewOverview/TabularView"
import { UserReviewOverview } from "./UserReviewOverview"
import ReviewOverview from "./ReviewOverview/ReviewOverview"
import { DatePicker } from "../common/DatePicker"
import CloseIcon from "@material-ui/icons/Close"
import { getReviewOverviewDetails, getUserReviewOverviewDetails, getUserReviewOverviewDetailsFailed } from "../../actions/infoActions"
import { setDashboardReview } from "../../actions/dashboardActions"

const useStyles = makeStyles((theme) => ({
	wrapper: {
		padding: 12,
		background: theme.palette.common.white,
	},
	cardHeader: {
		display: "flex",
		alignItems: "center",
		justifyContent: "space-between",
		marginTop: "4px",
	},
	sectionTitle: {
		fontWeight: 600,
	},
	title: {
		color: theme.palette.grey.D100,
		fontWeight: 400,
		marginLeft: "3px",
		paddingTop: 5,
	},
	dateWrapper: {
		position: "relative",
		width: 175,
		marginBottom: 4,
	},
	clearDate: {
		position: "absolute",
		right: 10,
		top: 22,
		color: theme.palette.grey[400],
		"& .MuiSvgIcon-root": {
			width: 18,
			height: 18,
		},
	},
	formField: {
		"& .MuiOutlinedInput-notchedOutline": {
			borderColor: "inherit",
		},
		"& fieldset > legend": {
			float: "none",
		},
		"& .MuiFormLabel-root, .MuiInputBase-input": {
			fontSize: 14,
		},
		"& .MuiSvgIcon-root": {
			width: 18,
			height: 18,
		},
	},
	conentWrapper: {
		paddingLeft: 12,
		paddingRight: 12,
	},
}))

function ReviewOverviewDashboard() {
	const theme = useTheme()
	const dispatch = useDispatch()
	const classes = useStyles()
	const [t] = useTranslation("global")

	const isCaseUser = useSelector((state) => state?.authtentication?.user?.user?.roles)?.includes(roles?.Case_User)
	const isCaseAdmin = useSelector((state) => state?.authtentication?.user?.user?.roles)?.includes(roles?.Case_Administrator)
	const selectedBaseId = useSelector((state) => state.multiBase.selectedBase.project_id)
	const review_overview = useSelector((state) => state?.info?.reviewOverviewDetails?.review_overview)

	const [isTableView, setIsTableView] = useState(false)
	const [dueDate, setDueDate] = useState(null)

	useEffect(() => {
		const payload = { is_table: isTableView, due_date: dueDate ? moment(dueDate).format("YYYY-MM-DD") : undefined }
		if (isCaseUser || isCaseAdmin) dispatch(getReviewOverviewDetails(payload))
	}, [dueDate, isTableView, selectedBaseId])

	const getUserReviewDetails = (reviewId) => {
		const payload = { id: reviewId, data: { is_table: isTableView } }
		reviewId && dispatch(getUserReviewOverviewDetails(payload))
	}

	useEffect(() => {
		if ((isTableView && review_overview?.length === 0) || (!isTableView && review_overview?.length === 1)) {
			dispatch(getUserReviewOverviewDetailsFailed())
			dispatch(setDashboardReview({}))
		}
	}, [review_overview, dueDate])

	return (
		<Paper elevation={0}>
			<Box className={classes.wrapper} style={{ paddingBottom: isTableView ? "" : 5 }}>
				<Grid container direction="row">
					<Grid item xs={12} style={{ display: "flex", alignItems: "center", paddingTop: 16 }} justifyContent="space-between">
						<Typography variant="subtitle1" className={classes.sectionTitle}>
							{t("review.review")}
						</Typography>
						<TableViewSwitch isTableView={isTableView} setIsTableView={setIsTableView} />
					</Grid>

					<Grid container className={classes.conentWrapper}>
						<Grid item xs={12} className={classes.cardHeader}>
							<Typography variant="subTitle2" className={classes.title}>
								{isCaseUser && !isCaseAdmin ? t("dashboard.yourReviewOverview") : t("dashboard.reviewOverview")}
							</Typography>
						</Grid>

						{(isTableView && review_overview?.length !== 0) ||
							(!isTableView && review_overview?.length !== 1 && (
								<Grid item xs={12}>
									<div className={classes.dateWrapper}>
										<DatePicker
											label={"Due by date"}
											date={dueDate}
											setDate={setDueDate}
											className={`${classes.formField}`}
											isClearDate={dueDate ? true : false}
										/>
										{dueDate && (
											<IconButton className={classes.clearDate} onClick={() => setDueDate(null)} title="Clear Date">
												<CloseIcon />
											</IconButton>
										)}
									</div>
								</Grid>
							))}

						<Grid item xs={12}>
							{isTableView ? (
								<Paper elevation={0}>
									<TabularView getUserReviewDetails={getUserReviewDetails} />
									{isCaseAdmin && (
										<>
											<UserReviewHeader />
											<UserReviewTabularView getUserReviewDetails={getUserReviewDetails} />
										</>
									)}
								</Paper>
							) : (
								(isCaseAdmin || isCaseUser) && (
									<Paper elevation={0}>
										<ReviewOverview getUserReviewDetails={getUserReviewDetails} />

										{isCaseAdmin && (
											<>
												<UserReviewHeader /> <UserReviewOverview getUserReviewDetails={getUserReviewDetails} />
											</>
										)}
									</Paper>
								)
							)}
						</Grid>
					</Grid>
				</Grid>
			</Box>
		</Paper>
	)
}

export default ReviewOverviewDashboard
